<script>
export default {
    methods: {
        validateStep3() {
            const data = this.SelectedData;
            const errors = [];
            if(this.accountData.CustomerType != 'corporate') {
                if(!data.firstName) {
                    errors.push('First Name');
                }
                if(!data.lastName) {
                    errors.push('Last Name');
                }
                if(!data.address1) {
                    errors.push('Address');
                }
                if(!data.city) {
                    errors.push('City');
                }
                if(!data.state.value) {
                    errors.push('State');
                }
                if(!data.zip) {
                    errors.push('Zip');
                }
                if(!data.country.value) {
                    errors.push('Country');
                }
                if(
                    data.birthday.mm < 1 || 
                    data.birthday.mm > 12 ||
                    data.birthday.dd < 1 || 
                    data.birthday.dd > 31 ||
                    data.birthday.yy < 0 || 
                    data.birthday.yy > 99 ||
                    !data.birthday.mm || 
                    !data.birthday.dd || 
                    !data.birthday.yy ||
                    !/^\d+$/.test(data.birthday.mm) || 
                    !/^\d+$/.test(data.birthday.dd) || 
                    !/^\d+$/.test(data.birthday.yy)
                ) {
                    errors.push('Birthday');
                } else if(
                    data.birthday.mm != data.confirmBirthday.mm || 
                    data.birthday.dd != data.confirmBirthday.dd || 
                    data.birthday.yy != data.confirmBirthday.yy
                ) {
                    errors.push('Confirm Birthdate');
                }
                if(!data.email) {
                    errors.push('Email');
                }
                if(data.email != data.confirmEmail) {
                    errors.push('Email Doesn\'t Match');
                }
                console.log(data.email);
                console.log(data.billingData.paymentType);
                if(!data.billingData.paymentType) {
                    errors.push('Payment Type');
                } else if(data.billingData.paymentType == 'cc') {
                    if(!data.billingData.creditCardType) {
                        errors.push('Credit Card Number Wrong or not Supported Credit Card Type');
                    }
                    if(!data.billingData.creditCardNumber) {
                        errors.push('Credit Card Number');
                    }
                    if(!data.billingData.cvv2Number) {
                        errors.push('Security Code');
                    }
                    if(!data.billingData.expirationDate.mm || !data.billingData.expirationDate.yy) {
                        errors.push('Expiration Date');
                    }
                }
            }

            if(errors.length) {
                this.errors = errors;
                this.$refs.checkouttop.scrollIntoView({ behavior: "smooth", })
                return false;
            }
            this.errors = false;
            return true;
        }
    }
}
</script>